export default __webpack_public_path__ + "static/media/Wij-kopen-vastgoed.3a54b5aa.png";